import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ReactFlowProvider } from "@xyflow/react";
import { OverlayProvider } from "@pikoloo/darwin-ui";
import "@pikoloo/darwin-ui/styles.css";
import "@xyflow/react/dist/style.css";
import "./styles/globals.css";
import "./styles/canvas.css";
import App from "./App";
import { registerBuiltinComponents } from "./core/builtin-components";
import { registerKimnoteComponent } from "./core/component-registry";

registerBuiltinComponents();

declare global {
  interface Window {
    Kimnote: {
      registerComponent: typeof registerKimnoteComponent;
    };
  }
}

window.Kimnote = { registerComponent: registerKimnoteComponent };

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OverlayProvider>
      <ReactFlowProvider>
        <App />
      </ReactFlowProvider>
    </OverlayProvider>
  </StrictMode>,
);
